export const FilterModalClose = 'FilterModalClose'
export const FilterModalOpen = 'FilterModalOpen'
export const FilterSelect = 'FilterSelect'
export const FilterSelectReset = 'FilterSelectReset'

export const QuickFilterClick = 'quick_filter_click'
